<template>
	<div style="display: flex; flex-direction: column; gap: 8px">
		<div v-if="store.loadingMeasurements">
			<div class="loader" style="margin: auto"></div>
		</div>
		<div v-else-if="store.measureResult === null">
			<p>{{ $t("weld.measuringMode.selectPrompt") }}</p>
		</div>
		<div v-else v-for="(dataPoint, index) in dataPoints" :key="index" class="measurement-box">
			<strong>{{ dataPoint.title }}:</strong><br />
			<span v-for="measurement in dataPoint.measurements" :key="measurement">
				{{ measurement }}<br />
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useMainStore } from "@/store/mainStore";
import { computed } from "vue";

const store = useMainStore();

const dataPoints = computed((): { title: string; measurements: string[] }[] => {
	if (!store.measureResult) return [];
	let points: { title: string; measurements: string[] }[] = [];
	// only show angle and minimal distance if exactly 2 features are selected

	store.measureResult.elementMeasureResults.forEach((result) => {
		let measurements = [];
		for (const measurement of result.measureValues) {
			measurements.push(`${measurement.name}: ${measurement.value} ${measurement.unit}`);
		}
		let newPoint = { title: result.elementType, measurements: measurements };
		points.push(newPoint);
	});

	return points;
});
</script>
<style scoped>
.measurement-box {
	padding: 12px;
	border: 1px solid var(--default-border-color);
	background-color: white;
	border-radius: 4px;
}
</style>
